import ActivePosterPreview from '@/components/poster/ActivePosterPreview'
import { Button } from '@runtime/components/ui/Button'
import { useI18n } from '@runtime/core/i18n/i18n'
import { openPosterOrAlert } from '@runtime/features/poster/logic/openPosterOrAlert'
import styles from './PlayPosterButton.module.scss'

export default function PlayPosterButton({
  className,
  onClick = openPosterOrAlert,
  testId,
}: {
  className?: string
  onClick?: () => void
  testId: string
}) {
  const { t } = useI18n()
  const label = t('common.poster')

  return (
    <Button
      size="s"
      className={[styles.button, className].filter(Boolean).join(' ')}
      onClick={onClick}
      data-testid={testId}
    >
      <ActivePosterPreview
        className={styles.thumbnail}
        width={24}
        height={24}
        loading="lazy"
        testId="play-poster-thumbnail"
      />
      {label}
    </Button>
  )
}
